import {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

export const useNewsFilters = (refetchNews: () => void) => {
	const {t} = useTranslation();
	const [searchParams] = useSearchParams();

	// Filter states
	const [currentCategory, setCurrentCategory] = useState<number | null>(null);
	const [currentCategoryName, setCurrentCategoryName] = useState<string>(
		t('По категорії'),
	);
	const [currentMonth, setCurrentMonth] = useState<string | null>(null);
	const [currentMonthName, setCurrentMonthName] = useState<string>(
		t('По місяцю'),
	);
	const [currentText, setCurrentText] = useState<string>('');
	const [currentTag, setCurrentTag] = useState<number | null>(null);

	// UI states
	const [openCategory, setOpenCategory] = useState(false);
	const [openCalendar, setOpenCalendar] = useState(false);
	const [openSearchInput, setOpenSearchInput] = useState(false);

	// Handle query params
	useEffect(() => {
		const tagParam = searchParams.get('tag');
		const categoryParam = searchParams.get('category');
		if (tagParam) {
			const tid = Number(tagParam);
			if (!Number.isNaN(tid)) {
				setCurrentTag(tid);
			}
			setCurrentCategory(null);
			setCurrentCategoryName(t('По категорії'));
			setCurrentMonth(null);
			setCurrentMonthName(t('По місяцю'));
		}
		if (categoryParam) {
			const cid = Number(categoryParam);
			if (!Number.isNaN(cid)) {
				setCurrentCategory(cid);
				setCurrentTag(null);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchParams]);

	// Handlers
	const handleChangeCategory = (id: number) => {
		setOpenCategory(false);
		setCurrentCategory(id);
	};

	const handleClickLupa = async () => {
		await refetchNews();
		setCurrentText('');
		setOpenSearchInput(false);
	};

	const handleChangeListItem = (id: number, type: string, catName?: string) => {
		if (type === 'tag') {
			setCurrentTag(id);
			setCurrentCategory(null);
			setCurrentCategoryName(t('По категорії'));
		} else if (type === 'category') {
			setCurrentCategory(id);
			setCurrentCategoryName(catName ?? '');
			setCurrentTag(null);
		}
		setCurrentMonthName(t('По місяцю'));
		setCurrentMonth(null);
	};

	return {
		// Filter values
		currentCategory,
		currentCategoryName,
		currentMonth,
		currentMonthName,
		currentText,
		currentTag,
		// UI states
		openCategory,
		openCalendar,
		openSearchInput,
		// Setters
		setCurrentCategory,
		setCurrentCategoryName,
		setCurrentMonth,
		setCurrentMonthName,
		setCurrentText,
		setCurrentTag,
		setOpenCategory,
		setOpenCalendar,
		setOpenSearchInput,
		// Handlers
		handleChangeCategory,
		handleClickLupa,
		handleChangeListItem,
	};
};

